export const textEllipsis = (text: string, max: number) =>
  text?.length > max ? `${text.substring(0, max)}...` : text;
